<div class="row px-2 pb-3" [ngClass]="{ freemium: isFreemium }">
  <div class="col-lg-6">
    <div class="container-fluid pl-0 pt-3 info-list-2 has-info-icon" [ngClass]="{ freemium: isFreemium }">
      <ng-container *ngIf="!data?.cookieBanner?.crawledState">
        <strong>Not crawled</strong>
      </ng-container>
      <ng-container *ngIf="data?.cookieBanner?.crawledState">
        <ng-container *ngIf="data?.cookieBanner?.cookieHomePageUrl | hideIfInvalid">
          <info-list-item label='Cookie Home Page' [lock]='isFreemium' [link]='data?.cookieBanner?.cookieHomePageUrl'
            [value]='data?.cookieBanner?.cookieHomePageUrl'></info-list-item>
        </ng-container>
        <ng-container *ngIf="data?.cookieBanner?.consentProvider | hideIfInvalid">
          <info-list-item label='Consent Provider' [lock]='isFreemium'
            [value]='data?.cookieBanner?.consentProvider'></info-list-item>
        </ng-container>
        <ng-container *ngIf="data?.cookieBanner?.cookieUrlLastCrawledTimestamp | hideIfInvalid">
          <info-list-item label='Crawl DateTime' [lock]='isFreemium'
            [value]='data?.cookieBanner?.cookieUrlLastCrawledTimestamp | date:"long"'></info-list-item>
        </ng-container>
        <ng-container *ngIf="data?.cookieBanner?.cookieCrawledLocation | hideIfInvalid">
          <info-list-item label='Crawled from Location' [lock]='isFreemium'
            [value]='data?.cookieBanner?.cookieCrawledLocation'></info-list-item>
        </ng-container>
      </ng-container>
    </div>
  </div>
  <div class="col-lg-6">
    <div class="container-fluid pl-0 pt-3 info-list has-info-icon" [ngClass]="{ freemium: isFreemium }">
      <ng-container *ngIf="data?.cookieBanner?.cookieScreenshotLocation | hideIfInvalid">
        Screenshot
        <div class="image-cont">
          <img class="image {{ preview }}" (click)="showImage()"
            [attr.src]="data?.cookieBanner?.cookieScreenshotLocation" alt="Image Data" />
        </div>
      </ng-container>
    </div>
  </div>
</div>